<template>
  <div id="subPage">
    <a-row class="pageProperty-btn">
      <a-tooltip placement="topLeft">
        <template slot="title">
          <span>{{ $t('roleGe.Add')}}</span>
        </template>
        <img style="margin-left: 10px" @click="EditAddSubPage('add')" class="sbxs" src="../../../assets/img/ss-add.png"  width="22" height="22">
      </a-tooltip>
      <a-popconfirm
        :title="$t('generic.AreyoudeleTask')"
        @confirm="delateSubPage"
        :okText="$t('generic.Yes')"
        :cancelText="$t('generic.No')"
      >
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t('roleGe.Delete')}}</span>
          </template>
          <img style="margin: 0 10px" class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
        </a-tooltip>
      </a-popconfirm>
      <a-tooltip placement="topLeft">
        <template slot="title">
          <span>{{ $t('generic.Up') }}</span>
        </template>
        <a-button
          size="small"
          type="primary"
          shape="circle"
          icon="arrow-up"
          style="background: #719844;border:none"
          @click="arrowUpEvent"
        ></a-button>
      </a-tooltip>
      <a-tooltip placement="topLeft">
        <template slot="title">
          <span>{{ $t('generic.Down') }}</span>
        </template>
        <a-button
          size="small"
          type="primary"
          shape="circle"
          icon="arrow-down"
          style="background: #ef4b12;border:none"
          @click="arrowDown"
        ></a-button>
      </a-tooltip>
      <a-tooltip placement="topLeft">
        <template slot="title">
          <span>{{ $t('generic.Store') }}</span>
        </template>
        <img @click="sortPagepro" class="sbxs" src="../../../assets/img/ss-save.png"  width="22" height="22">
      </a-tooltip>
    </a-row>
    <a-table
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      :dataSource="subPageData"
      :columns="columns"
      :pagination="Nopagination"
      :loading="loading"
      size="small"
      :locale="tabelText"
    >
      <template
        v-for="(item, index) in scopedSlotsArray"
        :slot="item"
        slot-scope="text"
      >
        <span :key="index">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span class="tableFontSize">{{
                text === "1" || text === true
                  ? "Yes"
                  : text === "0" || text === false
                  ? "No"
                  : text === ""
                  ? "-"
                  : text
              }}</span>
            </template>
            <div class="tableFontSize">
              {{
                text === "1" || text === true
                  ? "Yes"
                  : text === "0" || text === false
                  ? "No"
                  : text === ""
                  ? "-"
                  : text
              }}
            </div>
          </a-tooltip>
        </span>
      </template>
      <img slot="operation" slot-scope="text"  @click="EditAddSubPage('edit', text)" class="sbxs" src="../../../assets/img/ss-edit.png"  width="22" height="22">
    </a-table>

    <a-modal
      title="Sub Page"
      centered
      v-model="visible"
      width="60%"
      :maskClosable="maskClosable"
      @cancel="cancelSubpage"
    >
      <template slot="footer">
        <a-button type="danger" @click="resettingSubPage">{{ $t('publicLang.Clear') }}</a-button>
        <a-button type="primary" @click="getSubpageConfig">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item :label="$t('generic.TableName')" v-bind="formItemLayout">
              <a-input
                size="small"
                :placeholder="$t('generic.TableName')"
                autocomplete="off"
                v-decorator="[
                  'name',
                  {
                    initialValue: editSubpageVal.tabName,
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
              <a-cascader
                :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                size="small"
                :options="gmcuidModule"
                expandTrigger="hover"
                @change="GetchageGenericName"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'module',
                  {
                    initialValue:[editSubpageVal.moduleCode,editSubpageVal.subModuleCode],
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>


     <a-col :span="12">
            <a-form-item :label="$t('generic.EnglishName')" v-bind="formItemLayout">
              <a-input
                size="small"
                :placeholder="$t('generic.EnglishName')"
                autocomplete="off"
                v-decorator="[
                  'englishName',
                  {
                    initialValue: editSubpageVal.englishName,
                    rules: [{ required: false, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>


                    <a-col :span="12">
            <a-form-item :label="$t('generic.CnName')" v-bind="formItemLayout">
              <a-input
                size="small"
                :placeholder="$t('generic.CnName')"
                autocomplete="off"
                v-decorator="[
                  'simplCnName',
                  {
                    initialValue: editSubpageVal.simplCnName,
                    rules: [{ required: false, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>

        <a-col :span="12">
            <a-form-item :label="$t('generic.TraditionalCNName')" v-bind="formItemLayout">
              <a-input
                size="small"
                :placeholder="$t('generic.TraditionalCNName')"
                autocomplete="off"
                v-decorator="[
                  'tradiCnName',
                  {
                    initialValue: editSubpageVal.tradiCnName,
                    rules: [{ required: false, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>

        <a-col :span="12">
            <a-form-item :label="$t('generic.KorName')" v-bind="formItemLayout">
              <a-input
                size="small"
                :placeholder="$t('generic.KorName')"
                autocomplete="off"
                v-decorator="[
                  'korName',
                  {
                    initialValue: editSubpageVal.korName,
                    rules: [{ required: false, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.thName')" v-bind="formItemLayout">
              <a-input
                      size="small"
                      :placeholder="$t('generic.thName')"
                      autocomplete="off"
                      v-decorator="[
                  'thName',
                  {
                    initialValue: editSubpageVal.thName,
                    rules: [{ required: false, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.jpName')" v-bind="formItemLayout">
              <a-input
                      size="small"
                      :placeholder="$t('generic.jpName')"
                      autocomplete="off"
                      v-decorator="[
                  'jpName',
                  {
                    initialValue: editSubpageVal.jpName,
                    rules: [{ required: false, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>




          <a-col :span="12">
            <a-form-item :label="$t('generic.Function')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                allowClear
                size="small"
                @change="GetchageGenericName"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'functionKey',
                  {
                    initialValue: editSubpageVal.functionKey,
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in gmcuidfunction"
                  :value="item.functionKey"
                  :key="index"
                  >{{ item.functionValue }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Loadable')" v-bind="formItemLayout">
              <a-switch
                size="small"
                v-decorator="[
                  'loadable',
                  {
                    valuePropName: 'checked',
                    initialValue: editSubpageVal.loadable
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.GenericName')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                size="small"
                allowClear
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'gmcUid',
                  {
                    initialValue: editSubpageVal.gmcUid,
                    rules: [
                      { required: true, message: 'Required' }
                    ]
                  }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in gmcuidGeneric"
                  :value="item.uid"
                  :key="index"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.IsExtra')" v-bind="formItemLayout">
              <a-switch
                size="small"
                v-decorator="[
                  'isExtra',
                  {
                    valuePropName: 'checked',
                    initialValue: editSubpageVal.isExtra
                  }
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.ExtraParameters')" v-bind="formItemLayout">
              <a-input
                  :placeholder="$t('generic.ExtraParameters')"
                  size="small"
                  autocomplete="off"
                  v-decorator="[
                  'extraParam',
                  {
                    initialValue: editSubpageVal.extraParam,
                  }
                ]"
              />
            </a-form-item>
          </a-col>

        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
import { mapState } from "vuex";
export default {
  data() {
    return {
      maskClosable: false,
      tabelText: {
        emptyText: "No record found"
      },
      Nopagination: false,
      visible: false,
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      subPageData: [],
      selectedRowKeys: [],
      checkrows: [],
      loading: false,
      gmcuidModule: [],
      gmcuidfunction: [], // 配置gmc-uid function下拉数据
      gmcuidGeneric: [], // 配置gmc-uid genericNameSeclect下拉数据
      paramsVo: {
        functionCode: "",
        moduleCode: "",
        subModuleCode: ""
      },
      editSubpageVal: {},
      scopedSlotsArray: ["tabName", "moduleCode", "functionName", "loadable"]
    };
  },
  computed: {
      columns(){
         return [
             {
                 title: this.$t('generic.TableName'),
                 dataIndex: "tabName",
                 scopedSlots: { customRender: "tabName" }
             },
             {
                 title: this.$t('generic.Module'),
                 dataIndex: "moduleCode",
                 scopedSlots: { customRender: "moduleCode" }
             },
             {
                 title: this.$t('generic.Function'),
                 dataIndex: "functionName",
                 scopedSlots: { customRender: "functionName" }
             },
             {
                 title: this.$t('generic.Loadable'),
                 dataIndex: "loadable",
                 scopedSlots: { customRender: "loadable" }
             },
             {
                 title: this.$t('generic.Action'),
                 scopedSlots: { customRender: "operation" }
             }
         ]
      },
    ...mapState(["uid"]) // 获取uid
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  watch: {
    uid(val) {
      if (val != "") {
        this.initSubpageTable();
      }
    }
  },
  created() {
    this.initSubpageTable();
  },
  methods: {
    //      初始化数据
    initSubpageTable() {
      this.loading = true;
      if (this.uid === "") {
        this.loading = false;
        return;
      }
      let params = {
        uid: this.uid
      };
      ajax.get(api.GETSUBPAGE, params).then(res => {
        this.loading = false;
        this.subPageData = res.data;
      });
    },
    //    删除subPage
    delateSubPage() {
      if (this.checkrows.length > 0) {
        let paramsArray = [];
        for (let ii in this.checkrows) {
          paramsArray.push(this.checkrows[ii].subpageUid);
        }
        let params = {
          subPageUid: paramsArray
        };
        ajax.post(api.DELETESUBPAGE, params).then(res => {
          if (res.code === 200) {
            this.initSubpageTable();
            this.selectedRowKeys = [];
          }
        });
      } else {
        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
      }
    },
    //      确定排序
    sortPagepro() {
      this.loading = true;
      let propertySortVo = this.subPageData;
      ajax.post(api.SORTPROPRTTYDETAIL, propertySortVo).then(res => {
        if (res.code === 200) {
          this.initSubpageTable();
          this.selectedRowKeys = [];
        }
      });
    },
    //      往上排序
    arrowUpEvent() {
      if (this.selectedRowKeys.length != 1) {
         this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
      } else {
        let index = this.getIndexOfSel(this.selectedRowKeys[0]);
        if (index == 0) {
          return false;
        }
        let ab = this.subPageData;
        let temp = ab[index - 1];

        let SeqTemp1 = ab[index].seq;
        let seqTemp2 = ab[index - 1].seq;
        ab[index - 1].seq = SeqTemp1;
        ab[index].seq = seqTemp2;

        ab[index - 1] = ab[index];
        ab[index] = temp;
        this.subPageData = ab;
        this.$forceUpdate();
      }
    },
    //      往下排序
    arrowDown() {
      let index = this.getIndexOfSel(this.selectedRowKeys[0]);
      let ii = parseInt(index) + 1;
      if (ii > this.subPageData.length - 1) {
        return false;
      }
      let ab = this.subPageData;
      let SeqTemp1 = ab[ii].seq;
      let seqTemp2 = ab[index].seq;
      ab[ii].seq = seqTemp2;
      ab[index].seq = SeqTemp1;

      let temp = ab[ii];
      ab[ii] = ab[index];
      ab[index] = temp;

      this.subPageData = ab;
      this.$forceUpdate();
    },
    //      过滤网上网下
    getIndexOfSel(val) {
      for (let ii in this.subPageData) {
        if (this.subPageData[ii].key === val) {
          return ii;
        }
      }
    },
    //      下拉数据获取
    EditAddSubPage(type, text) {
        if (this.uid === "") {
        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
        return;
      }
        this.visible = true;
      ajax.get(api.GETMODULEDROPDATA).then(res => {
        this.gmcuidModule = res.data;
      });
      ajax.get(api.GETFUNCTIONDROPDATA).then(res => {
        this.gmcuidfunction = res.data;
      });
        this.editSubpageVal = {};
        this.paramsVo = {}
      if (type === "add") {
        this.form.resetFields();
      } else {
        this.editSubpageVal = text;
          console.log(this.editSubpageVal);
        this.editSubpageVal.loadable = this.editSubpageVal.loadable === "1" ? true : false;
        this.editSubpageVal.isExtra = this.editSubpageVal.isExtra === "1" ? true : false;
        this.paramsVo.moduleCode =  this.editSubpageVal.moduleCode
        this.paramsVo.subModuleCode =  this.editSubpageVal.subModuleCode
        this.paramsVo.functionCode = this.editSubpageVal.functionKey
        this.getgenericNameajaxfn()
      }
    },
    //      change触发gemcuid
    GetchageGenericName(item) {
        if (typeof item == "object") {
        let modulesArr = item;
        this.paramsVo.moduleCode = modulesArr[0];
        this.paramsVo.subModuleCode = modulesArr[1];
      } else {
        this.paramsVo.functionCode = item;
      }
      this.getgenericNameajaxfn();
    },
    //      获取gmcId
    getgenericNameajaxfn() {
      let params = this.paramsVo;
      if (params.functionCode == "" || params.moduleCode == "") {
        this.gmcuidGeneric = [];
        return;
      }
      ajax.post(api.POSTFETCH, params).then(res => {
          this.gmcuidGeneric = res.data;
      });
    },
    getSubpageConfig() {
      this.form.validateFields((err, params) => {
        if (!err) {
          let moduleVal = params.module;
          params.modeleCode = moduleVal[0];
          params.subModeleCode = moduleVal[1];
          params.loadable = params.loadable ? "1" : "0";
          params.isExtra = params.isExtra ? "1" : "0";
          params.parentGmcUid = this.uid;
          params.subPageUid = this.editSubpageVal.subpageUid;
          params.langCode =  this.editSubpageVal.langCode;
          params.seq = this.editSubpageVal.seq;
          ajax.post(api.SAVESUBPAGE, params).then(res => {
            if (res.code === 200) {
              this.visible = false;
              this.editSubpageVal = {}
              this.resettingSubPage()
              this.initSubpageTable();
            }
          });
        }
      });
    },
    //      table 所选中
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.checkrows = selectedRows;
    },
    cancelSubpage(){
        this.visible = false
        this.form.resetFields();
    },
    resettingSubPage() {
      this.form.resetFields();
    }
  }
};
</script>
<style lang="less">
#subPage {
  margin-top: 14px;
  .pageProperty-btn {
    margin-bottom: 14px;
    button {
      margin-right: 10px;
    }
  }
}
</style>
